
import React from "react";
import Highlight from "./Highlight";
import styles from "../../assets/style.module.css";

export interface PageHeadProps {
    kicker?: string;
    title: string;
    subtitle?: string;
    children?: React.ReactNode;
}

function PageHead({ kicker, title, subtitle, children }: PageHeadProps) {
    return (<section className={styles["page-head"]}>
        <div className={styles["container"]}>
            {kicker && (<span className={styles["tag"]}>{kicker}</span>)}
            <h1 className={styles["jumbo"]}><Highlight text={title} /></h1>
            {subtitle && (<p className={styles["lead"]}>{subtitle}</p>)}
            {children}
        </div>
    </section>);
}

export default PageHead;
